import Entity from './entity'
export default class WareHouse extends Entity<number>{
    wname:string;
    status:Number=1;
}